import type { IFooterViewModel } from "../Types/LoginTypes";

const linkClasses =
  "text-white/40 hover:text-white/80 transition-colors duration-200";

const LoginFooter = ({ vm }: { vm: IFooterViewModel }) => (
  <footer className="mt-auto flex flex-col gap-3 text-white/40 text-xs sm:flex-row sm:items-center">
    <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
      <span>{vm.labels.copyrightText}</span>
      <a
        href={vm.labels.privacyHref}
        className={linkClasses}
        target="_blank"
        rel="noopener noreferrer"
      >
        {vm.labels.privacyText}
      </a>
      <a
        href={vm.labels.termsHref}
        className={linkClasses}
        target="_blank"
        rel="noopener noreferrer"
      >
        {vm.labels.termsText}
      </a>
    </div>
    <div className="flex flex-wrap items-center gap-x-5 gap-y-2 sm:ml-auto">
      <span className="font-semibold text-white/70">
        {vm.labels.needHelpText}
      </span>
      <a
        href={vm.labels.chatLink}
        className={linkClasses}
        target="_blank"
        rel="noopener noreferrer"
      >
        {vm.labels.chatToUsText}
      </a>
    </div>
  </footer>
);

export default LoginFooter;
